(function () {
  var CHAT_STORAGE_PREFIX = 'kabarai-widget-history::';
  var ANON_ID_KEY = 'kabarai-anon-id';
  var MAX_SAVED_EXCHANGES = 12;
  var MAX_SAVED_MESSAGES = MAX_SAVED_EXCHANGES * 2;
  var CHAT_TTL_MS = 7 * 24 * 60 * 60 * 1000;

  function parseReply(data) {
    if (data && typeof data.text === 'string') {
      return data.text.trim();
    }

    if (
      data &&
      data.candidates &&
      data.candidates[0] &&
      data.candidates[0].content &&
      data.candidates[0].content.parts
    ) {
      return data.candidates[0].content.parts
        .map(function (part) {
          return part.text || '';
        })
        .join('')
        .trim();
    }

    return '';
  }

  function getStorageKey(endpoint) {
    var suffix = (endpoint || 'default')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return CHAT_STORAGE_PREFIX + (suffix || 'default');
  }

  function storageAvailable() {
    try {
      var testKey = '__kabarai_storage_test__';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function createId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      var random = Math.random() * 16 | 0;
      var value = char === 'x' ? random : (random & 0x3 | 0x8);
      return value.toString(16);
    });
  }

  function getAnonymousId() {
    if (!storageAvailable()) return createId();

    try {
      var existing = window.localStorage.getItem(ANON_ID_KEY);
      if (existing) return existing;

      var id = createId();
      window.localStorage.setItem(ANON_ID_KEY, id);
      return id;
    } catch (error) {
      return createId();
    }
  }

  function buildUserId(customerId) {
    var trimmed = customerId ? String(customerId).trim() : '';
    if (trimmed) return 'shopify-customer:' + trimmed;
    return 'anon:' + getAnonymousId();
  }

  function trimHistory(history) {
    var safeHistory = Array.isArray(history) ? history.slice() : [];
    var initial = safeHistory[0] && safeHistory[0].role === 'bot'
      ? [safeHistory[0]]
      : [];
    var conversation = safeHistory.slice(initial.length);

    if (conversation.length > MAX_SAVED_MESSAGES) {
      conversation = conversation.slice(-MAX_SAVED_MESSAGES);
    }

    return initial.concat(conversation);
  }

  function sanitizeHistory(history, greeting) {
    var fallback = [{ role: 'bot', text: greeting }];
    if (!Array.isArray(history)) return fallback;

    var normalized = history
      .map(function (message) {
        if (!message || typeof message !== 'object') return null;

        var role = message.role === 'user' ? 'user' : 'bot';
        var text = typeof message.text === 'string' ? message.text.trim() : '';
        if (!text) return null;

        return { role: role, text: text };
      })
      .filter(Boolean);

    if (!normalized.length) return fallback;
    if (normalized[0].role !== 'bot') {
      normalized.unshift({ role: 'bot', text: greeting });
    }

    return trimHistory(normalized);
  }

  function loadStoredSession(storageKey, greeting, currentUserId) {
    var freshSession = {
      history: sanitizeHistory(null, greeting),
      conversationId: createId(),
      userId: currentUserId,
      isNewConversation: true
    };

    if (!storageAvailable()) return freshSession;

    try {
      var raw = window.localStorage.getItem(storageKey);
      if (!raw) return freshSession;

      var parsed = JSON.parse(raw);
      var savedAt = parsed && typeof parsed.savedAt === 'number' ? parsed.savedAt : 0;

      if (!savedAt || Date.now() - savedAt > CHAT_TTL_MS) {
        window.localStorage.removeItem(storageKey);
        return freshSession;
      }

      var storedUserId = parsed && typeof parsed.userId === 'string' ? parsed.userId : '';
      var identityChanged = Boolean(storedUserId && storedUserId !== currentUserId);
      var conversationId = parsed && typeof parsed.conversationId === 'string' && parsed.conversationId
        ? parsed.conversationId
        : createId();

      if (identityChanged) {
        conversationId = createId();
      }

      return {
        history: sanitizeHistory(parsed.history, greeting),
        conversationId: conversationId,
        userId: currentUserId,
        isNewConversation: identityChanged || !parsed.conversationId
      };
    } catch (error) {
      return freshSession;
    }
  }

  function persistSession(storageKey, session) {
    var trimmedHistory = trimHistory(session.history);
    session.history = trimmedHistory;

    if (storageAvailable()) {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify({
          savedAt: Date.now(),
          history: trimmedHistory,
          conversationId: session.conversationId,
          userId: session.userId
        }));
      } catch (error) {}
    }

    return session;
  }

  function clearStoredHistory(storageKey) {
    if (!storageAvailable()) return;

    try {
      window.localStorage.removeItem(storageKey);
    } catch (error) {}
  }

  function getExpandIconMarkup(expanded) {
    if (expanded) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 4H4v5M15 4h5v5M20 15v5h-5M4 15v5h5" /></svg>';
    }

    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 4H4v4M16 4h4v4M20 16v4h-4M4 16v4h4" /></svg>';
  }

  function initWidget(root) {
    if (!root || root.dataset.kabaraiInitialized === 'true') return;
    root.dataset.kabaraiInitialized = 'true';

    var endpoint = root.dataset.endpoint || '';
    var greeting = root.dataset.greeting || "Hello! I'm KabarAI, an AI assistant trained on the research of Dr. Jon J. Kabara, who discovered monolaurin in 1966. How can I help you with your health journey today?";
    var openLabel = root.dataset.openLabel || 'Ask KabarAI';
    var closeLabel = root.dataset.closeLabel || 'Close KabarAI';
    var userId = buildUserId(root.dataset.customerId || '');

    var chatWindow = root.querySelector('[data-kabarai-window]');
    var chatBackdrop = root.querySelector('[data-kabarai-backdrop]');
    var chatToggle = root.querySelector('[data-kabarai-toggle]');
    var headerToggles = document.querySelectorAll('[data-kabarai-header-toggle]');
    var chatClose = root.querySelector('[data-kabarai-close]');
    var chatExpand = root.querySelector('[data-kabarai-expand]');
    var chatClear = root.querySelector('[data-kabarai-clear]');
    var chatMessages = root.querySelector('[data-kabarai-messages]');
    var chatForm = root.querySelector('[data-kabarai-form]');
    var chatInput = root.querySelector('[data-kabarai-input]');
    var chatLabel = chatToggle ? chatToggle.querySelector('span:last-child') : null;
    var allToggles = [];

    if (chatToggle) allToggles.push(chatToggle);
    headerToggles.forEach(function (toggle) {
      if (allToggles.indexOf(toggle) === -1) allToggles.push(toggle);
    });

    if (!chatWindow || !chatClose || !chatMessages || !chatForm || !chatInput || !allToggles.length) {
      return;
    }

    var storageKey = getStorageKey(endpoint);
    var isChatLoading = false;
    var isExpanded = false;
    var previousHtmlOverflow = '';
    var previousBodyOverflow = '';
    var session = loadStoredSession(storageKey, greeting, userId);
    var chatHistory = session.history;
    var conversationId = session.conversationId;
    var isNewConversation = session.isNewConversation;

    function setPageScrollLocked(locked) {
      if (!document || !document.documentElement || !document.body) return;

      if (locked) {
        previousHtmlOverflow = document.documentElement.style.overflow;
        previousBodyOverflow = document.body.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        return;
      }

      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
    }

    function syncExpandedState() {
      root.classList.toggle('is-expanded', isExpanded);
      if (chatExpand) {
        chatExpand.innerHTML = getExpandIconMarkup(isExpanded);
        chatExpand.setAttribute('aria-label', isExpanded ? 'Collapse chat' : 'Expand chat');
      }
    }

    function resizeChatInput() {
      if (!chatInput) return;
      chatInput.style.height = 'auto';
      chatInput.style.height = Math.min(chatInput.scrollHeight, 120) + 'px';
    }

    function resetChatInput() {
      if (!chatInput) return;
      chatInput.value = '';
      resizeChatInput();
    }

    function addChatMessage(role, text, options) {
      var shouldScrollToBottom = options && options.scrollToBottom;
      var row = document.createElement('div');
      row.className = 'kabarai-widget__row ' + role;

      var bubble = document.createElement('div');
      bubble.className = 'kabarai-widget__bubble ' + role;
      bubble.textContent = text;

      row.appendChild(bubble);
      chatMessages.appendChild(row);
      if (shouldScrollToBottom) {
        chatMessages.scrollTop = chatMessages.scrollHeight;
      }
    }

    function syncClearState() {
      if (chatClear) {
        chatClear.disabled = isChatLoading || chatHistory.length <= 1;
      }
    }

    function renderChatHistory() {
      chatMessages.innerHTML = '';
      chatHistory.forEach(function (message) {
        addChatMessage(message.role, message.text);
      });
      syncClearState();
    }

    function scrollToBottom() {
      chatMessages.scrollTop = chatMessages.scrollHeight;
    }

    function scrollLatestBotReplyIntoView() {
      var botRows = chatMessages.querySelectorAll('.kabarai-widget__row.bot:not([data-kabarai-loading])');
      var latestBotRow = botRows[botRows.length - 1];
      if (!latestBotRow) return;
      var latestBotBubble = latestBotRow.querySelector('.kabarai-widget__bubble.bot');

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          if (latestBotBubble && typeof latestBotBubble.scrollIntoView === 'function') {
            latestBotBubble.scrollIntoView({ block: 'start', behavior: 'auto' });
          } else {
            chatMessages.scrollTop = Math.max(0, latestBotRow.offsetTop - 8);
          }
        });
      });
    }

    function persistChatHistory() {
      session = persistSession(storageKey, {
        history: chatHistory,
        conversationId: conversationId,
        userId: userId
      });
      chatHistory = session.history;
      conversationId = session.conversationId;
      syncClearState();
    }

    function resetChatHistory() {
      chatHistory = [{ role: 'bot', text: greeting }];
      conversationId = createId();
      isNewConversation = true;
      clearStoredHistory(storageKey);
      persistChatHistory();
      renderChatHistory();
    }

    function setChatLoading(isLoading) {
      var sendButton = chatForm.querySelector('.kabarai-widget__send');
      var existing = chatMessages.querySelector('[data-kabarai-loading]');

      chatInput.disabled = isLoading;
      if (sendButton) sendButton.disabled = isLoading;

      if (isLoading && !existing) {
        var row = document.createElement('div');
        row.className = 'kabarai-widget__row bot';
        row.setAttribute('data-kabarai-loading', 'true');
        row.innerHTML = '<div class="kabarai-widget__bubble bot is-loading"><div class="kabarai-widget__dots"><span></span><span></span><span></span></div></div>';
        chatMessages.appendChild(row);
        scrollToBottom();
      }

      if (!isLoading && existing) existing.remove();
      syncClearState();
    }

    function toggleExpand(forceExpanded) {
      var nextExpanded = typeof forceExpanded === 'boolean' ? forceExpanded : !isExpanded;

      if (nextExpanded && !chatWindow.classList.contains('is-open')) {
        toggleChat(true);
      }

      isExpanded = nextExpanded && chatWindow.classList.contains('is-open');
      setPageScrollLocked(isExpanded);
      syncExpandedState();

      if (isExpanded) {
        window.setTimeout(function () {
          scrollLatestBotReplyIntoView();
          chatInput.focus();
        }, 60);
      }
    }

    function syncToggleState(open) {
      allToggles.forEach(function (toggle) {
        toggle.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? closeLabel : openLabel);
      });

      if (chatLabel) {
        chatLabel.textContent = open ? closeLabel : openLabel;
      }
    }

    function toggleChat(forceOpen) {
      var open = typeof forceOpen === 'boolean' ? forceOpen : !chatWindow.classList.contains('is-open');

      if (!open && isExpanded) {
        isExpanded = false;
        setPageScrollLocked(false);
      }

      chatWindow.classList.toggle('is-open', open);
      syncToggleState(open);
      syncExpandedState();

      if (open) {
        window.setTimeout(function () {
          chatInput.focus();
        }, 100);
      }
    }

    async function requestChatReply(userMessage) {
      if (!endpoint) {
        throw new Error('ENDPOINT_MISSING');
      }

      var controller = new AbortController();
      var timeoutId = window.setTimeout(function () {
        controller.abort();
      }, 30000);

      try {
        var payload = {
          message: userMessage,
          conversationId: conversationId,
          userId: userId
        };

        if (isNewConversation) {
          payload.title = userMessage;
        }

        var response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          signal: controller.signal,
          body: JSON.stringify(payload)
        });

        var data = {};
        try {
          data = await response.json();
        } catch (error) {
          data = {};
        }

        if (!response.ok) {
          var message = data && typeof data.error === 'string'
            ? data.error
            : data && data.error && data.error.message
              ? data.error.message
              : 'Request failed.';
          throw new Error(message);
        }

        if (data && typeof data.conversation_id === 'string' && data.conversation_id) {
          conversationId = data.conversation_id;
        }

        isNewConversation = false;
        persistChatHistory();

        var reply = parseReply(data);
        if (!reply) {
          throw new Error('EMPTY_RESPONSE');
        }

        return reply;
      } finally {
        window.clearTimeout(timeoutId);
      }
    }

    function closeNavDrawer() {
      if (window.theme && theme.NavDrawer && typeof theme.NavDrawer.close === 'function') {
        theme.NavDrawer.close();
        return;
      }

      var closeButton = document.querySelector('#NavDrawer .js-drawer-close');
      if (closeButton) closeButton.click();
    }

    function handleToggleClick(event, toggle) {
      event.preventDefault();
      event.stopPropagation();

      var fromDrawer = Boolean(toggle.closest('#NavDrawer'));
      var shouldOpen = !chatWindow.classList.contains('is-open');

      if (fromDrawer) closeNavDrawer();

      window.setTimeout(function () {
        toggleChat(shouldOpen);
      }, fromDrawer ? 480 : 0);
    }

    allToggles.forEach(function (toggle) {
      if (toggle.hasAttribute('data-kabarai-header-toggle')) return;
      toggle.addEventListener('click', function (event) {
        handleToggleClick(event, toggle);
      });
    });

    document.addEventListener('click', function (event) {
      var element = event.target && event.target.nodeType === 3 ? event.target.parentElement : event.target;
      var toggle = element && element.closest ? element.closest('[data-kabarai-header-toggle]') : null;
      if (!toggle || allToggles.indexOf(toggle) === -1) return;
      handleToggleClick(event, toggle);
    }, true);

    chatClose.addEventListener('click', function () {
      toggleChat(false);
    });

    if (chatExpand) {
      chatExpand.addEventListener('click', function () {
        toggleExpand();
      });
    }

    if (chatBackdrop) {
      chatBackdrop.addEventListener('click', function () {
        if (!isExpanded) return;
        toggleExpand(false);
      });
    }

    if (chatClear) {
      chatClear.addEventListener('click', function () {
        if (isChatLoading) return;
        resetChatHistory();
        resetChatInput();
        chatInput.focus();
      });
    }

    chatInput.addEventListener('input', function () {
      resizeChatInput();
    });

    chatInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        if (typeof chatForm.requestSubmit === 'function') {
          chatForm.requestSubmit();
        } else {
          chatForm.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (isExpanded) {
        toggleExpand(false);
        return;
      }
      if (chatWindow.classList.contains('is-open')) {
        toggleChat(false);
      }
    });

    renderChatHistory();
    resizeChatInput();
    syncToggleState(false);

    chatForm.addEventListener('submit', async function (event) {
      event.preventDefault();
      var value = chatInput.value.trim();
      if (!value || isChatLoading) return;

      isChatLoading = true;
      chatHistory.push({ role: 'user', text: value });
      persistChatHistory();
      resetChatInput();
      renderChatHistory();
      scrollToBottom();
      setChatLoading(true);

      try {
        var reply = await requestChatReply(value);
        chatHistory.push({ role: 'bot', text: reply });
        persistChatHistory();
        renderChatHistory();
        scrollLatestBotReplyIntoView();
      } catch (error) {
        console.error('KabarAI chat error:', error);
        var errorMessage = 'I encountered an error. Please check your connection and try again.';
        var message = error && error.message ? error.message : '';
        var errorName = error && error.name ? error.name : '';

        if (message === 'ENDPOINT_MISSING') {
          errorMessage = 'The AI assistant endpoint is not configured yet.';
        } else if (errorName === 'AbortError' || message === 'The operation was aborted.') {
          errorMessage = 'The AI assistant took too long to respond. Please try again.';
        } else if (message.indexOf('403') > -1 || message.toLowerCase().indexOf('forbidden') > -1) {
          errorMessage = 'The AI assistant is currently unavailable. Please try again shortly.';
        } else if (message === 'EMPTY_RESPONSE') {
          errorMessage = 'I was unable to generate a response just now. Please try again.';
        } else if (message) {
          errorMessage = 'I encountered an error connecting to the AI assistant: ' + message;
        }

        chatHistory.push({ role: 'bot', text: errorMessage });
        persistChatHistory();
        renderChatHistory();
        scrollLatestBotReplyIntoView();
      } finally {
        isChatLoading = false;
        setChatLoading(false);
        chatInput.focus();
      }
    });
  }

  function initAllWidgets() {
    document.querySelectorAll('[data-kabarai-widget]').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllWidgets);
  } else {
    initAllWidgets();
  }

  document.addEventListener('shopify:section:load', initAllWidgets);
})();
